// src/lib/vorabLaden.js
// --- WARTUNGEN FUER UNTERWEGS VORAB LADEN -------------------------------------
// Anna-Lena 15.09.2026 (Vorschlag 11): Die naechsten Wartungen sollen auf dem
// Handy liegen, bevor der Monteur ins Funkloch faehrt. Die Startseite ruft das
// automatisch auf, sobald sie mit Netz geladen hat.
//
// Je Wartung wird genau das abgelegt, was die Protokollseite ohne Netz braucht:
//   - Protokoll mit allen Kapiteln und Pruefpunkten (etb-protokoll-cache-<id>)
//   - Stammdaten der Station                        (etb-station-cache-<id>)
//   - Werte der letzten Wartung                     (etb-vorwartung-<id>)
// Streng nacheinander und hoechstens alle 30 Minuten je Wartung - das Handy
// soll dafuer nicht warm werden.

import { protokollVollLaden, protokollZwischenspeichern } from '../hooks/useProtokoll';
import { stationDatenLaden, stationZwischenspeichern } from '../hooks/useStationen';
import { lieferscheineLaden, originaleVorladen } from './lieferscheine';
import { vorWartungVorladen } from './vorWartung';
import { offeneAenderungen } from './warteschlange';
import { erderDatenLaden } from '../pages/ErderanlageBlock';

const ZULETZT = 'etb-vorab-zuletzt';
const PAUSE_MS = 30 * 60 * 1000;

function zuletztLesen() {
  try { return JSON.parse(sessionStorage.getItem(ZULETZT) || '{}') || {}; } catch { return {}; }
}
function zuletztMerken(id) {
  try {
    const z = zuletztLesen();
    z[id] = Date.now();
    sessionStorage.setItem(ZULETZT, JSON.stringify(z));
  } catch { /* egal */ }
}

export function istVorabGeladen(protokollId) {
  try { return !!localStorage.getItem('etb-protokoll-cache-' + protokollId); } catch { return false; }
}
export function vorabGeladeneAnzahl(liste) {
  return (liste || []).filter(p => p?.id && istVorabGeladen(p.id)).length;
}

let laufend = null;
let naechsteListe = null;

// liste: am besten geplante zuerst (die Startseite gibt sie so herein).
export function wartungenVorladen(liste, { max = 5 } = {}) {
  if (laufend) {
    // Kommt waehrend des Ladens eine frischere Liste, danach noch einmal.
    naechsteListe = { liste, max };
    return laufend;
  }
  laufend = (async () => {
    const z = zuletztLesen();
    const auswahl = (liste || []).filter(p => p?.id).slice(0, max);
    for (const p of auswahl) {
      if (!navigator.onLine) break;
      if (z[p.id] && Date.now() - z[p.id] < PAUSE_MS) continue;
      try {
        const beginn = Date.now();
        const { protokoll, module } = await protokollVollLaden(p.id);
        // Wartendes aus der Warteschlange ist neuer als der Server-Stand -
        // erst JETZT lesen, nicht vor der Schleife.
        const offen = offeneAenderungen();
        const mitOffenen = module.map(m => ({
          ...m, pruefpunkte: m.pruefpunkte.map(pp => (offen[pp.id] ? { ...pp, ...offen[pp.id] } : pp)),
        }));
        protokollZwischenspeichern(p.id, protokoll, mitOffenen, { nurWennAelterAls: beginn });
        if (protokoll.station_id) {
          const daten = await stationDatenLaden(protokoll.station_id);
          stationZwischenspeichern(protokoll.station_id, daten, { nurWennAelterAls: beginn });
          await erderDatenLaden(protokoll.station_id).catch(() => null);
        }
        await vorWartungVorladen(protokoll).catch(() => null);
        // Lieferscheine gleich mit aufs Geraet - unterschrieben wird oft im Keller ohne Netz.
        await lieferscheineLaden(p.id).then(({ liste }) => originaleVorladen(liste)).catch(() => null);
        zuletztMerken(p.id);
      } catch {
        // Eine Wartung scheitert (Netz weg, geloescht) - die naechste versuchen.
      }
    }
  })().finally(() => {
    laufend = null;
    const n = naechsteListe;
    naechsteListe = null;
    if (n) wartungenVorladen(n.liste, { max: n.max });
  });
  return laufend;
}
